<template>
    <div id="contents">
    <div class="contents_wrap">
        <h2 class="pg_title">{{pageTitle}}</h2>
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
        <!-- //breadcrumbs -->

        <div v-show="mode === MODE.SEARCH">
            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w49">
                            <li class="tit_150">{{ $t('FIELD.FAQ.CORP') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="rhqCd" @change="changeRhqCd()">
                                            <option v-if="rhqCdList.length > 1" value="" selected >{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="corpNo" @change="changeCorpNo()">
                                            <option v-if="corpNoList.length != 1" value selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>

                        <ul class="w49">
                            <li class="tit_150">Country</li>
                            <li data-input-type="select" class="w100-150">
                                <select
                                    class="slt_white w100"
                                    v-model="selectedCountry"
                                    :disabled="rhqCd === ''"
                                >
                                    <option value="">Select</option>
                                    <option
                                        v-for="item in availableCountryList"
                                        :key="item.CODE_ID"
                                        :value="item.CODE_ID"
                                    >{{item.CODE_NAME}}</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49"">
                            <li class="tit_150">First Approver</li>
                            <li class="w100-150">
                                <span class="clearable">
                                    <input type="text" class="text_input w100"
                                        minlength="4"
                                        maxlength="30"
                                        v-model="firstApprover"
                                        v-clearable
                                    />
                                </span>
                            </li>
                        </ul>
                        <ul class="w49"">
                            <li class="tit_150">Second Approver</li>
                            <li class="w100-150">
                                <span class="clearable">
                                    <input type="text" class="text_input w100"
                                        minlength="4"
                                        maxlength="30"
                                        v-model="secondApprover"
                                        v-clearable
                                    />
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="srch_grupR">
                        <span class="btn">
                            <a href="javascript:" class="btn_srch"
                            @click="onSearchButtonClick">Search</a>
                        </span>
                    </div>
                </article>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <!-- Grid Count-->
                <div class="grid_total">
                    Total Count
                    <em>{{ resultCount | numberFormat }}</em>
                </div>
                <!-- Grid "btn-->
                <div class="btn_wrap">
                    <div class="btn_right">
                        <a href="javascript:"
                            class="btn_gray"
                            @click="onCreateButtonClick">
                                Create
                        </a>
                    </div>
                </div>
                <!-- Grid -->
                <div id="grid">
                    <toast-grid
                        gridId="gridApprovalManagement"
                        :key="gridKey"
                        :data="gridData"
                        :columns="gridColumns"
                        :options="gridOptions"
                        :pageOptions="gridPageOptions"
                        :theme="gridTheme"
                        :isTotalCount="false"
                        v-bind:click="onGridCellClick"
                    />
                </div>

                <div class="paginate">
                    <sdl-pagination
                        :current-page="currentPage"
                        :total-rows="resultCount"
                        :per-page="perPage"
                        @change="onGoToPage"
                        align="center"
                    />
                </div>

            </div>
        </div>

        <approval-management-create v-if="mode === MODE.CREATE"
            v-bind:onBackToList="onBackToList"
        ></approval-management-create>

        <approval-management-modify v-if="mode === MODE.MODIFY"
            :countryCode="modifyItem.countryCode"
            :countryName="modifyItem.countryName"
            :firstApproverId="modifyItem.firstApproverId"
            :secondApproverId="modifyItem.secondApproverId"
            v-bind:onBackToList="onBackToList"
        ></approval-management-modify>
    </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import { mapGetters } from 'vuex';
import { SDLUtil, StringUtil } from '@/utils';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import ApprovalManagementModify from './ApprovalManagementModify';
import ApprovalManagementCreate from './ApprovalManagementCreate';
import api from '@/service';
import { param } from 'jquery';

const MODE = {
    SEARCH: 'search',
    CREATE: 'create',
    MODIFY: 'modify',
};

// Toast Grid Custom Renderer
class CustomButtonRenderer {
    constructor(props) {
        const el = document.createElement('a');
        el.classList.add('btn_sm_white');
        const { text } = props.columnInfo.renderer.options;
        el.innerText = text;
        el.href = 'javascript:';
        this.el = el;
    }

    getElement() {
        return this.el;
    }
}

class CustomIconRenderer {
    constructor(props) {
        //<em data-v-6416ff38="" class="textbgbox_hot ml10">X</em>
        // <em data-v-6416ff38="" class="textbgbox_recommend ml10">O</em>

        const el = document.createElement('em');
        // const { status } = props.columnInfo.renderer.options;
        // console.log('props.value', props);
        if (props.value === 1) {
            el.classList.add('textbgbox_recommend');
            el.innerHTML = 'O';

        } else {
            el.classList.add('textbgbox_hot');
            el.innerHTML = 'X';
        }
        el.classList.add('ml10');
        this.el = el;
    }

    getElement() {
        return this.el;
    }
}
export default {
    name: 'hhp-approval-management',

    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
        'approval-management-modify': ApprovalManagementModify,
        'approval-management-create': ApprovalManagementCreate,
    },

    props: [],

    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
        availableCountryCodeList() {
            return this.availableCountryList.map(item => item.CODE_ID);
        }
    },

    data() {
        return {
            MODE,
            mode: MODE.SEARCH,
            pageTitle: '',
            rhqCd: '',
            rhqCdList: [],
            corpNo: '',
            corpNoList: [],
            availableSubsidiaryList: [],
            availableCountryList: [],
            selectedCountry: '',
            firstApprover: '',
            secondApprover: '',
            lastSearchParams: {},

            modifyItem: {
                countryCode: '',
                countryName: '',
                firstApproverId: '',
                secondApproverId: '',
            },

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],
            gridColumns: [
                {
                    header: 'Country',
                    name: 'COUNTRY_NM',
                    align: 'center',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'First Approver',
                    name: 'F_APPROVER_ID',
                    align: 'center',
                    resizable: true,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Status',
                    name: 'F_CK',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: {
                        type: CustomIconRenderer,
                    },
                },
                {
                    header: 'Role',
                    name: 'F_ROLE_CD',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    // renderer: {
                    //     type: CustomButtonRenderer,
                    //     options: { text: 'Update' }
                    // },
                },
                {
                    header: 'Update Role',
                    name: 'F_ROLE_UPDATE',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: {
                        type: CustomButtonRenderer,
                        options: { text: 'Update' }
                    },
                },
                {
                    header: 'Second Approver',
                    name: 'S_APPROVER_ID',
                    align: 'center',
                    resizable: true,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Status',
                    name: 'S_CK',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: {
                        type: CustomIconRenderer,
                    },
                },
                {
                    header: 'Role',
                    name: 'S_ROLE_CD',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    // renderer: {
                    //     type: CustomButtonRenderer,
                    //     options: { text: 'Update' }
                    // }
                },
                {
                    header: 'Update Role',
                    name: 'S_ROLE_UPDATE',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: {
                        type: CustomButtonRenderer,
                        options: { text: 'Update' }
                    }
                },
                {
                    header: 'Update Date',
                    name: 'UPDATE_DATE',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
        };
    },

    created() {
        // this.init();
        this.doSearch(1);
    },
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            await this.fetchInitData()
                .then(data => {
                    console.log('FetchInitData', data);
                    // this.setSubsidiaryList(data.subsidiaryList);
                    this.setCountryList(data.countryList);
                    // this.setAvailableCountryList(data.countryList);
                    // this.setAvailableCategoryList(data.firstCategoryCombo);
                    // this.setAvailableContentTypeList(data.contentList);
                })
                .catch(err => {
                    Vue.$log.error("Approval Mgmt Err: ", err)
                });


            SDLUtil.showLoadingBar(false);
        },

        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },

        loadSubsiCodes(mode, pCode) {
            if (mode == 1) {
                // RhqCd
                this.getCodeComboList(this.getLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                    this.rhqCdList = data;
                    if (this.rhqCdList.length == 1) this.rhqCd = this.rhqCdList[0].code;
                    if (this.rhqCd) this.loadSubsiCodes(2, this.rhqCdList[0].code);
//                    else this.corpNo = '';
                });
            } else if (mode == 2) {
                // CorpNo
                this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                    this.corpNoList = data;
                    if (this.corpNoList.length == 1) this.corpNo = this.corpNoList[0].code;
                    else                             this.corpNo = '';
                });
            }
        },

        fetchInitData() {
            const params = { };
            if (this.rhqCd) {
                params.rhqCd = this.rhqCd;
            }
            if (this.corpNo) {
                params.subsidiary_cd = this.corpNo;
            }
            console.log(this.rhqCd + " ##### " + this.corpNo);
            return axios
                // Loads data such as list of countries, etc...
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/approvalMgmt/ApprovalMgmt.skp`,
                    { params }
                )
                .then(res => {
                    console.log('APPROVAL MGMT', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error("Approval Mgmt: ", err)
                    if (['HHP_FORBIDDEN', '401', '403'].includes(err.data.error.code)) {
                        this.$router.push({path: '/basis/certificate/CertWarning'});
                        return err.data.error;
                    }

                    return err.data.error;
                });
        },

        setSubsidiaryList(list) {
            if (typeof list === 'undefined' || list == null) return;
            list = list.map(item => {
                return {
                    CODE_ID: item.SUBSIDIARY_CD,
                    CODE_NAME: item.SUBSIDIARY_NM,
                };
            });
            this.availableSubsidiaryList = list;
        },

        onSubsidiaryChange() {
            this.selectedCountry = '';
            this.availableCountryList = [];
            this.firstApprover = '';
            this.secondApprover = '';
            this.init();

            // 김남갑 수정
            this.gridData   = [];
            this.gridKey     = 0;
            this.resultCount = 0;
        },

        changeRhqCd() {
            this.selectedCountry = '';
            this.availableCountryList = [];
            this.firstApprover = '';
            this.secondApprover = '';
            this.corpNo = '';
            this.corpNoList = [];
            this.loadSubsiCodes(2, this.rhqCd);
            this.init();
            // 김남갑 수정
            this.gridData   = [];
            this.gridKey     = 0;
            this.resultCount = 0;
        },

        changeCorpNo() {
            this.selectedCountry = '';
            this.availableCountryList = [];
            this.firstApprover = '';
            this.secondApprover = '';
            this.init();
            // 김남갑 수정
            this.gridData   = [];
            this.gridKey     = 0;
            this.resultCount = 0;
        },

        setCountryList(list) {
            if (typeof list === 'undefined' || list == null) return;
            list = list.map(item => {
                return {
                    CODE_ID: item.CDCODE,
                    CODE_NAME: item.CDDESC,
                };
            });
            this.availableCountryList = list;
        },

        onSearchButtonClick() {
            this.doSearch(1);
        },

        async doSearch(pageNo) {
            // if (!this.validateSearchParams()) return;

            const params = this.prepSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            const data = await this.fetchSearchResult(params);
            SDLUtil.showLoadingBar(false);
            if (Object.prototype.hasOwnProperty.call(data, 'error')) {
                // on Error
                const title = 'Error';
                const msg = data.message;
                SDLUtil.alert({ title, msg });
                return;
            }

            this.lastSearchParams = params;
            this.currentPage = pageNo;

            this.setGridData(data.rows, data.count);
        },

        validateSearchParams() {
            if (this.rhqCd !== '' && this.selectedCountry === '') {
                const title = 'Invalid Input';
                const msg = 'Please select a country.';
                SDLUtil.alert({ title, msg });
                return false;
            }

            // if (this.selectedCountry === '') {
            //     const title = 'Invalid Input';
            //     const msg = 'Please select a country.';
            //     SDLUtil.alert({ title, msg });
            //     return false;
            // }

            return true;
        },

        prepSearchParams(pageNo) {
            const params = {
                page: pageNo,
                // approvalType: '', // Only used for update role.1, 2
                f_approver_id: this.firstApprover,
                s_approver_id: this.secondApprover,
            };
            if(this.selectedCountry) {
                params.country_cd = this.selectedCountry;
            } else {
                params.countryList = this.availableCountryCodeList;
            }

            return params;
        },

        fetchSearchResult(params) {
            const formData = qs.stringify(params);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/approvalMgmt/ApprovalMgmtSearch.skp`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: { searchInfo: 'set' },
                    },
                )
                .then(res => {
                    // console.log('SEARCH RESULT', res);
                    return res.data;
                });
        },

        setGridData(rows, count) {
            if (rows === undefined) {
                this.gridData = [];
            } else {
                this.gridData = rows;
            }

            this.gridKey += 1;
            if (count === undefined) {
                this.resultCount = 0;
            } else {
                this.resultCount = count;
            }
        },

        onGoToPage(pageNo) {
            // this.lastSearchParams.page = pageNo;
            return this.doSearch(pageNo);
        },

        onCreateButtonClick() {
            this.switchMode(MODE.CREATE);
        },

        onGridCellClick(e, rowData, grid) {
            const columnName = e.columnName;
            const row = rowData[e.rowKey];

            console.log('CLICKED ', e, rowData, grid);
            console.log('CellData ', columnName, row);

            if (columnName === 'F_APPROVER_ID' || columnName === 'S_APPROVER_ID') {
                this.setModifyData(
                    row.COUNTRY_CD,
                    row.COUNTRY_NM,
                    row.F_APPROVER_ID,
                    row.S_APPROVER_ID,
                );
                this.switchMode(MODE.MODIFY);
            }

            if (columnName === 'F_ROLE_UPDATE') {
                this.updateRole('1',
                    row.F_APPROVER_ID,
                    row.S_APPROVER_ID,
                    row.COUNTRY_CD,
                ).then(res => {
                    this.doSearch(this.currentPage);
                });
            }

            if (columnName === 'S_ROLE_UPDATE') {
                this.updateRole('2',
                    row.F_APPROVER_ID,
                    row.S_APPROVER_ID,
                    row.COUNTRY_CD,
                ).then(res => {
                    this.doSearch(this.currentPage);
                });
            }

        },

        updateRole(approvalType, firstApproverId, secondApproverId, countryCode) {
            // This is a strage function. The same API is used for Search and Update.
            // When approvalType is included in the param, it will do update.
            const params = {
                approvalType: approvalType, // 1, 2
                country_cd: countryCode,
                f_approver_id: firstApproverId,
                s_approver_id: secondApproverId,
            };

            const formData = qs.stringify(params);
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/approvalMgmt/ApprovalMgmtSearch.skp`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: { searchInfo: 'set' },
                    },
                )
                .then(res => {
                    SDLUtil.showLoadingBar(false);
                    console.log('UPDATE RESULT', res);
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                });
        },

        setModifyData(countryCode, countryName, firstApproverId, secondApproverId) {
            this.modifyItem = {
                countryCode,
                countryName,
                firstApproverId,
                secondApproverId,
            };
        },

        switchMode(mode) {
            this.mode = mode;
        },

        onBackToList(hasUpdated=false) {
            this.switchMode(MODE.SEARCH);
            if (hasUpdated) {
                this.doSearch(1);
            } else {
                this.doSearch(this.currentPage);
            }
        },
    },

    mounted() {
        this.loadSubsiCodes(1, '');
    },
};
</script>

<style>
.zindex9999 {
    z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/approvalManagement/ApprovalManagement.vue